function toggleCollapse() {
    if (this.classList.contains('collapsed')) {
        this.classList.remove('collapsed');
        this.classList.add('expanded');
    } else {
        this.classList.remove('expanded');
        this.classList.add('collapsed');
    }


}

var collapseTriggers = document.querySelectorAll('.collapse, .collapse-mobile');

for (let i = 0; i < collapseTriggers.length; i++) {
    const element = collapseTriggers[i];
    element.addEventListener('click', function(el) {

      console.log(el.target);
        if(el.target.classList.contains('collapsed')) {
            el.target.classList.remove('collapsed');
            el.target.classList.add('expanded');
        } else {
            el.target.classList.remove('expanded');
            el.target.classList.add('collapsed');            
        }
    });
}